import { cn } from '../../lib/cn';

const statusConfig = {
  demonstrated: {
    bg: 'bg-green-100 dark:bg-green-900/30',
    text: 'text-green-700 dark:text-green-400',
    icon: '✓',
  },
  needs_practice: {
    bg: 'bg-amber-100 dark:bg-amber-900/30',
    text: 'text-amber-700 dark:text-amber-400',
    icon: '↻',
  },
  not_assessed: {
    bg: 'bg-gray-100 dark:bg-gray-700',
    text: 'text-gray-500 dark:text-gray-400',
    icon: '—',
  },
};

export default function SkillTag({
  name,
  status = 'not_assessed',
  showIcon = true,
  size = 'md',
  className,
}) {
  const config = statusConfig[status] || statusConfig.not_assessed;

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium',
        config.bg,
        config.text,
        sizes[size],
        className
      )}
    >
      {showIcon && <span>{config.icon}</span>}
      <span>{name}</span>
    </span>
  );
}

export function SkillTagList({ skills, className }) {
  if (!skills || skills.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {skills.map((skill, index) => (
        <SkillTag
          key={index}
          name={skill.name}
          status={skill.status}
        />
      ))}
    </div>
  );
}
